@if (!isLoading && isFullScreen) {
  <div class="main-container" data-cy="patient-portal-home-main-container">
    <div [class.main-left-container]="!isRightPanelMinimized"
      [class.main-left-container-expanded]="isRightPanelMinimized">
      <div class="content-container">
        <!-- PROFILE & CASES -->
        @if (patientInformation) {
          <div class="general-container">
            <div class="general-content-container profile-container" data-cy="patient-portal-home-profile-container">
              <div class="profile-image" data-cy="patient-portal-home-profile-image" (click)="activateImageView()">
                <app-file-manager-view #imageView [width]="150" [height]="150" [roundImage]="false" [roundCorners]="true"
                  [orientation]="'fixed'" viewType="single" previewType="patient" [LOCID]="LOCID"
                  enumDocumentTypeID="0000001C-1000-0000-0000-000000000003"
                [enumDocumentTags]="[DOCUMENT_TAG.PatientPicture]" [PatientId]="PatientId"></app-file-manager-view>
              </div>
              <div class="profile-info">
                <div class="profile-action-buttons">
                  <div class="warning-icon-container" data-cy="patient-portal-home-incomplete-warning" [matTooltip]="patientMissingInfo">
                    @if (!patientInformationComplete) {
                      <i class="material-icons warning-icon" data-cy="patient-portal-home-incomplete-warning-icon"
                      alt="Patient information incomplete">warning</i>
                    }
                  </div>
                  <div class="button" data-cy="patient-portal-home-edit-profile" style="width: 60px;float: right;" color="primary" (click)="editProfilePressed()">Edit
                  </div>
                </div>
                <!--PROFILE DATA-->
                <div>
                  <div style="color: var(--accented-text-color); font-size: 18px; max-width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" [title]="((Patient?.dataContact?.FirstName || '') + ' ' + (Patient?.dataContact?.LastName || '')).trim() || '--'" data-cy="patient-portal-home-patient-name-label">
                    {{ ((Patient?.dataContact?.FirstName || '') + ' ' + (Patient?.dataContact?.LastName || '')).trim() || '--' }}
                  </div>
                  <div class="patient-info">
                    <span style="color: var(--tdo-light-gray);" data-cy="patient-portal-home-patient-number-label">Patient # {{Patient?.PatientNO}}</span>
                    <div class="appointment-data" data-cy="patient-portal-home-patient-info-label">
                      <ng-container>
                        {{ patientBirthday?.format('DD MMM, YYYY') }}<br />
                        {{ patientBirthday? moment().diff(patientBirthday,'years') : '--'}} Years<br />
                        {{ patientPhoneNum }}<br />
                        {{ patientEmail }}<br />
                        {{ patientAddress }}
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vertical-separator"></div>
            @if (!activeAppointment) {
              <div class="general-content-container pre-appointment-container">
                <span class="container-title" data-cy="patient-portal-home-no-pending-appointments-text">No Pending Appointments</span>
              </div>
            }
            @if (activeAppointment) {
              <div class="general-content-container pre-appointment-container" data-cy="patient-portal-home-pre-appointment-container">
                <div>
                  <span class="container-title" data-cy="patient-portal-home-pre-appointment-title">Pre-Appointment Check-in </span>
                  @if (activeAppointment.enumApptStatusId === enumConfirmedStatus) {
                    <span data-cy="patient-portal-home-appointment-confirmed-status"> ( Confirmed )</span>
                  }
                  @if (!activeAppointment.isCancelled && activeAppointment.enumApptStatusId !== enumConfirmedStatus) {
                    <span data-cy="patient-portal-home-appointment-not-confirmed-status"> ( Not Confirmed - <span
                      class="text-button" style="padding: 5px;" data-cy="patient-portal-home-confirm-now-button"
                    (click)="confirmAppointment(activeAppointment)">Confirm Now</span> )</span>
                  }
                </div>
                <table class="pre-appointment-data">
                  <tr>
                    <td>
                      <div>
                        <div data-cy="patient-portal-home-appointment-date-label">{{ activeAppointment.appointmentDate.format('MMMM D YYYY') }}</div>
                        <div data-cy="patient-portal-home-appointment-time-label">{{ activeAppointment.appointmentDate.format('dddd, H:mm A')}}</div>
                      </div>
                    </td>
                    <td>
                      <div>
                        <div data-cy="patient-portal-home-appointment-doctor-label"><i class="tiny-icon material-symbols-outlined">stethoscope</i> with {{ activeAppointment.doctor
                      }}</div>
                      <div data-cy="patient-portal-home-appointment-procedure-label"><i class="tiny-icon material-symbols-outlined">dentistry</i>{{
                    activeAppointment.procedureDescription }}</div>
                  </div>
                </td>
                <td>
                  <div>
                    <div data-cy="patient-portal-home-appointment-location-label"><i class="tiny-icon material-symbols-outlined">map</i> {{ activeAppointment.locationAddress }}
                  </div>
                  <div data-cy="patient-portal-home-appointment-phone-label"><i class="tiny-icon material-symbols-outlined">call</i> {{ activeAppointment.locationPhone }}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div class="horizontal-separator"></div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div>
                <div data-cy="patient-portal-home-check-in-label">For Check-in</div>
                <div style="display: flex;">
                  <div class="button" data-cy="patient-portal-home-send-to-mobile-button" style="width: 160px;margin-top: 5px;" color="primary"
                    [class.disabled-content]="activeAppointment.isOld || activeAppointment.smsSent || isSendingSMS"
                    (click)="sendToMobile()" (onKeyPress)="SendToMobileKey($event)">
                    @if (!isSendingSMS) {
                      <span>Send to my Mobile</span>
                    }
                    @if (isSendingSMS) {
                      <mat-spinner class="mini-spinner" [diameter]="20"></mat-spinner>
                    }
                  </div>
                  <div class="button" data-cy="patient-portal-home-print-appointment-button" style="width: 100px;margin-top: 5px; margin-left: 15px;" color="primary"
                    [class.disabled-content]="activeAppointment.isOld" (click)="printAppointment(activeAppointment)">
                  Print</div>
                  <div>
                    <img alt="Open Map" data-cy="patient-portal-home-open-map-button"
                      style="height: 35px; cursor: pointer;float: right;margin-top: 5px; margin-left: 15px;"
                      (click)="openMap()" src="assets/Images/map-icon.png">
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div>
                  <div data-cy="patient-portal-home-complete-forms-label">Complete Your Forms</div>
                  @if (!formsLoading) {
                    <div class="general-content-container">
                      @if (!formsPending?.length) {
                        <div class="no-task-message" data-cy="patient-portal-home-no-tasks-message">
                          You have no tasks due at this time.
                        </div>
                      }
                      @if (formsPending?.length>0) {
                        <div class="task-name" data-cy="patient-portal-home-pending-forms-count">
                          You have {{ formsPending.length }} pending forms.
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (activeAppointment.correspondence.length>0) {
                  <div class="button" data-cy="patient-portal-home-correspondence-button"
                    style="width: 120px;margin-top: 5px; margin-left: 15px;" color="primary"
                  (click)="openCorrespondence(activeAppointment.AppointmentId)">Correspondence</div>
                }
              </td>
              <td>
              </td>
            </tr>
          </table>
        </div>
      }
    </div>
  }
</div>
<div class="content-container upcoming-appointments-container">
  <div class="container-title" data-cy="patient-portal-home-upcoming-appointments-title">Upcoming Appointments</div>
  <div class="general-container">
    <div class="general-content-container">
      @if (appointments?.length===0) {
        <div class="general-content-container pre-appointment-container">
          <span class="container-title" data-cy="patient-portal-home-no-upcoming-appointments-text">No Pending Appointments</span>
        </div>
      }
      @for (appointment of appointments; track appointment) {
        <div class="appointment" data-cy="patient-portal-home-upcoming-appointment-item" [disabled] ="appointment.isCancelled" (click)="selectAppointment(appointment)">
          <div class="appointment-content"
            [class.appointment-active]="activeAppointmentId === appointment.AppointmentId">
            <div class="appointment-upcoming-data">
              <div class="appointment-title" data-cy="patient-portal-home-upcoming-appointment-title-label">{{ appointment.displayTitle }} </div>
              <br><span data-cy="patient-portal-home-upcoming-appointment-procedure-label">{{ appointment.procedureDescription }}</span>
                <br><span data-cy="patient-portal-home-upcoming-appointment-doctor-label">{{ appointment.doctor }}</span>
                  <br><span data-cy="patient-portal-home-upcoming-appointment-location-label">{{ appointment.locationAddress }}</span>
                  </div>
                  <div class="appointment-actions" [class.disabled-content]="appointment.isOld" style="float:right">
                    @if (!appointment.isCancelled) {
                      <div class="button" data-cy="patient-portal-home-confirm-appointment-button" style="width: 160px;margin-top: 5px;" color="primary"
                        [class.disabled-content]="appointment.enumApptStatusId === enumConfirmedStatus || appointment.isOld"
                        (click)="confirmAppointment(appointment)">{{ appointment.enumApptStatusId ===
                        enumConfirmedStatus ?
                      'Confirmed' : 'Confirm Appointment' }}</div>
                    }
                    @if (!appointment.isCancelled) {
                      <div class="button" data-cy="patient-portal-home-reschedule-button" style="width: 160px;margin-top: 5px;" color="primary"
                        [class.disabled-content]="appointment.isOld" (click)="rescheduleAppointment(appointment)">Request
                      Reschedule</div>
                    }
                    @if (appointment.isCancelled) {
                      <div class="button" data-cy="patient-portal-home-cancelled-appointment-label" style="width: 160px;margin-top: 5px;" color="primary">Cancelled</div>
                    }
                  </div>
                </div>
                <div class="vertical-separator"></div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="content-container forms-container">
        <div class="container-title" data-cy="patient-portal-home-forms-title" style="height: 30px">Forms</div>
        <div class="general-container"
          style="min-height: calc(100% - 50px);max-height: calc(100% - 50px);overflow: auto">
          <div class="general-content-container" style="width: 100%">
            <div class="form-list">
              @for (treatment of patientTreatments; track treatment) {
                <div class="form-tile" [class.active-form]="selectedTreatmentPlanningID === treatment.TreatmentPlanningID"
                  data-cy="patient-portal-treatment"
                  [class.form-completed]="['Accepted', 'Rejected'].includes(treatment.Status)"
                  (click)="loadTreatmentToContainer(treatment)">
                  <span data-cy="patient-portal-form-description"
                    style="color: var(--accented-text-color);font-size: medium; font-weight: 600;">{{treatment.ParentDescription}}
                  - {{treatment.Description}}</span><br />
                  Status: <span style="font-size: medium;" data-cy="patient-portal-status"
                [class.status-completed]="'Accepted' === treatment.Status">{{treatment.Status}}</span>
              </div>
            }
            @for (patientForm of patientForms; track patientForm) {
              <div class="form-tile" [class.active-form]="selectedCaseWorkItemFormsID === patientForm.CaseWorkItemFormsId"
                data-cy="patient-portal-form"
                [class.form-completed]="['Completed/Signed', 'Completed'].includes(patientForm.Status)"
                (click)="loadFormToContainer(patientForm)">
                <span data-cy="patient-portal-form-description"
                style="color: var(--accented-text-color);font-size: medium; font-weight: 600;">{{patientForm.Description}}</span><br />
                Status: <span style="font-size: medium;" data-cy="patient-portal-status"
              [class.status-completed]="['Completed/Signed', 'Completed'].includes(patientForm.Status)">{{patientForm.Status}}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
<div [class.main-right-container]="!isRightPanelMinimized"
  [class.main-right-container-contracted]="isRightPanelMinimized">
  <span class="panel-toggle">
    @if (isRightPanelMinimized) {
      <span class="material-symbols-outlined" data-cy="patient-portal-home-expand-panel-button" style="margin-right:10px;" matTooltip="Expand Panel"
        (click)="toggleRightPanel()">
        chevron_left
      </span>
    }
    @if (!isRightPanelMinimized) {
      <span class="material-symbols-outlined" data-cy="patient-portal-home-collapse-panel-button" style="margin-right:10px;" matTooltip="Collapse Panel"
        (click)="toggleRightPanel()">
        chevron_right
      </span>
    }
  </span>
  <div class="content-container" [ngStyle]="{'display': (!isRightPanelMinimized) ? '' : 'none' }">
    <div class="general-content-container calendar-container">
      <app-tdo-mini-calendar #calendar [isGetAppointmentDays]="false" [daysToHighlight]="daysToHighlight"
      style="width: 350px;" (selectedDateChange)="calendarUpdate($event)"></app-tdo-mini-calendar>
      <div class="button" data-cy="patient-portal-home-request-appointment-button" style="width: 160px;margin-top: 5px;" color="primary"
      (click)="requestAppointment(appointment)">Request Appointment</div>
    </div>
  </div>
  <div class="content-container" [ngStyle]="{'display': (!isRightPanelMinimized) ? '' : 'none' }">
    <div class="container-title" data-cy="patient-portal-home-recent-appointments-title">Recent Appointments</div>
    <div class="recent-appointments-container">
      @if (oldAppointments?.length===0) {
        <div class="general-content-container recent-appointment-container">
          <span class="container-title" data-cy="patient-portal-home-no-previous-appointments-text">No Previous Appointments</span>
        </div>
      }
      @for (appt of oldAppointments; track appt) {
        <div class="appointment-data recent-entity" data-cy="patient-portal-home-recent-appointment-item">
          <div style="flex-direction: row; display: flex;">
            <div style="flex-direction: row; display: flex;width: 140px; flex-basis: 150px; margin:auto;">
              <div style="font-size: xx-large;width: 40px; font-weight: 700;" data-cy="patient-portal-home-recent-appointment-day-label">{{ appt.appointmentDate.format('D') }}
              </div>
              <div style="width: 100px;" data-cy="patient-portal-home-recent-appointment-date-label">{{ appt.appointmentDate.format('MMM, YYYY')}}<br />{{
                appt.appointmentDate.format('H:mm A')}}
              </div>
            </div>
            <div style="font-size: small; width: 200px;">
              <div data-cy="patient-portal-home-recent-appointment-doctor-label"><i class="tiny-icon material-symbols-outlined">stethoscope</i> {{ appt.doctor }}</div>
              <div data-cy="patient-portal-home-recent-appointment-procedure-label"><i class="tiny-icon material-symbols-outlined">dentistry</i> {{ appt.procedureDescription }}</div>
            </div>
            <div style="font-size: small; width: 200px;">
              <div data-cy="patient-portal-home-recent-appointment-location-label"><i class="tiny-icon material-symbols-outlined">map</i> {{ appt.locationAddress }}</div>
              <div data-cy="patient-portal-home-recent-appointment-phone-label"><i class="tiny-icon material-symbols-outlined">call</i> {{ appt.locationPhone }}</div>
            </div>
          </div>
          @if (appt.correspondence.length>0) {
            <div style="text-align: center;" data-cy="patient-portal-home-recent-correspondence-button"
              (click)="openCorrespondence(appt.AppointmentId)">
              <div class="correspondence-label">Correspondence</div>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div class="content-container" [ngStyle]="{'display': (!isRightPanelMinimized) ? '' : 'none' }">
    <div class="container-title" data-cy="patient-portal-home-pending-payments-title">Pending Payments</div>
    <div class="recent-invoices-container">
      @if (patientTransactions?.length===0) {
        <div class="general-content-container recent-appointment-container">
          <span class="container-title" data-cy="patient-portal-home-no-pending-transactions-text">No Pending Transactions</span>
        </div>
      }
      @for (transaction of patientTransactions; track transaction) {
        <div class="transaction-data-container recent-entity" data-cy="patient-portal-home-transaction-item"
          >
          <div class="transaction-data">
            <div style="flex-direction: row; display: flex;width: 140px; flex-basis: 150px;margin: auto;">
              <div style="font-size: xx-large;width: 40px; font-weight: 700;" data-cy="patient-portal-home-transaction-day-label">{{
              transaction.ItemDate.format('D') }}</div>
              <div style="width: 100px;" data-cy="patient-portal-home-transaction-date-label">{{ transaction.ItemDate.format('MMM, YYYY')}}<br />{{
                transaction.ItemDate.format('H:mm A')}}
              </div>
            </div>
            <div style="font-size: small; width: 200px;">
              @if (transaction.DoctorName) {
                <div data-cy="patient-portal-home-transaction-doctor-label"><i class="tiny-icon material-symbols-outlined">stethoscope</i> {{ transaction.DoctorName }}</div>
              }
              <div data-cy="patient-portal-home-transaction-location-label"><i class="tiny-icon material-symbols-outlined">map</i> {{ transaction.LocationName }}</div>
            </div>
            <div style="width: 100px; margin: auto;">
              <div data-cy="patient-portal-home-transaction-amount-label">{{ transaction.Amount | currency }}</div>
            </div>
          </div>
          <div style="text-align: center;">
            <div class="payment-pending" data-cy="patient-portal-home-transaction-payment-due-label">Your payment of {{transaction.AmountDuePatient | currency}} is due</div>
          </div>
        </div>
      }
      @if (patientTransactions?.length>0) {
        <div
          class="button"
          data-cy="pay-now-btn"
          style="width: 120px; margin: 10px auto; cursor: pointer;"
          color="primary"
          [class.disabled-content]="isRefreshingTransactions"
          (click)="openPayNowDialog()">
          @if (!isRefreshingTransactions) {
            <span>Pay Now</span>
          }
          @if (isRefreshingTransactions) {
            <mat-spinner class="mini-spinner" [diameter]="20"></mat-spinner>
          }
        </div>
      }
    </div>
  </div>
</div>
</div>
}
@if (!isLoading && (isTabletPortrait || isTabletLandscape|| isHandsetPortrait)) {
  <div class="tablet-container" data-cy="patient-portal-home-tablet-container" [ngClass]="{'ipad-device': isIPad}" style="overflow-y: auto !important;">
    <mat-accordion class="headers-align" multiple="false">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="panel-style" data-cy="patient-portal-home-patient-info-panel-header">
          <mat-panel-title data-cy="patient-portal-home-patient-info-panel-title"> Patient Information </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="general-content-container profile-container" data-cy="patient-portal-home-profile-container">
          <div class="profile-image" data-cy="patient-portal-home-profile-image" (click)="activateImageView()">
            <app-file-manager-view #imageView [width]="150" [height]="150" [roundImage]="false" [roundCorners]="true"
              [orientation]="'fixed'" viewType="single" previewType="patient" [LOCID]="LOCID"
              enumDocumentTypeID="0000001C-1000-0000-0000-000000000003" [enumDocumentTags]="[DOCUMENT_TAG.PatientPicture]"
            [PatientId]="PatientId"></app-file-manager-view>
          </div>
          <div class="profile-info">
            <div class="profile-action-buttons">
              <div class="warning-icon-container" data-cy="patient-portal-home-incomplete-warning" [matTooltip]="patientMissingInfo">
                @if (!patientInformationComplete) {
                  <i class="material-icons warning-icon" data-cy="patient-portal-home-incomplete-warning-icon"
                  alt="Patient information incomplete">warning</i>
                }
              </div>
              <div class="button" data-cy="patient-portal-home-edit-profile" style="width: 60px;float: right;" color="primary" (click)="editProfilePressed()">Edit
              </div>
            </div>
            <!--PROFILE DATA-->
            <div>
              <div style="color: var(--accented-text-color); font-size: 18px; max-width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" [title]="((Patient?.dataContact?.FirstName || '') + ' ' + (Patient?.dataContact?.LastName || '')).trim() || '--'" data-cy="patient-portal-home-patient-name-label">
                {{ ((Patient?.dataContact?.FirstName || '') + ' ' + (Patient?.dataContact?.LastName || '')).trim() || '--' }}
              </div>
              <div class="patient-info">
                <span style="color: var(--tdo-light-gray);" data-cy="patient-portal-home-patient-number-label">Patient # {{Patient?.PatientNO}}</span>
                <div class="patient-data" data-cy="patient-portal-home-patient-info-label">
                  <ng-container>
                    {{ patientBirthday?.format('DD MMM, YYYY') }}<br />
                    {{ patientBirthday? moment().diff(patientBirthday,'years') : '--'}} Years<br />
                    {{ patientPhoneNum }}<br />
                    {{ patientEmail }}<br />
                    {{ patientAddress }}
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header class="panel-style" data-cy="patient-portal-home-appointment-info-panel-header">
          <mat-panel-title data-cy="patient-portal-home-appointment-info-panel-title"> Appointment Information </mat-panel-title>
        </mat-expansion-panel-header>
        @if (!activeAppointment) {
          <div class="general-content-container pre-appointment-container">
            <span class="container-title" data-cy="patient-portal-home-no-pending-appointments-text">No Pending Appointments</span>
          </div>
        }
        @if (activeAppointment) {
          <div class="general-content-container pre-appointment-container" data-cy="patient-portal-home-pre-appointment-container">
            <div>
              <span class="container-title" data-cy="patient-portal-home-pre-appointment-title">Pre-Appointment Check-in </span>
              @if (activeAppointment.enumApptStatusId === enumConfirmedStatus) {
                <span data-cy="patient-portal-home-appointment-confirmed-status"> ( Confirmed )</span>
              }
              @if (activeAppointment.enumApptStatusId !== enumConfirmedStatus) {
                <span data-cy="patient-portal-home-appointment-not-confirmed-status"> ( Not Confirmed - <span
                  class="text-button" style="padding: 5px;" data-cy="patient-portal-home-confirm-now-button"
                (click)="confirmAppointment(activeAppointment)">Confirm Now</span> )</span>
              }
            </div>
            <table class="pre-appointment-data">
              <tr>
                <td>
                  <div>
                    <div data-cy="patient-portal-home-appointment-date-label">{{ activeAppointment.appointmentDate.format('MMMM D YYYY') }}</div>
                    <div data-cy="patient-portal-home-appointment-time-label">{{ activeAppointment.appointmentDate.format('dddd, H:mm A')}}</div>
                  </div>
                </td>
                <td>
                  <div>
                    <div data-cy="patient-portal-home-appointment-doctor-label"><i class="tiny-icon material-symbols-outlined">stethoscope</i> with {{ activeAppointment.doctor
                  }}</div>
                  <div data-cy="patient-portal-home-appointment-procedure-label"><i class="tiny-icon material-symbols-outlined">dentistry</i>{{
                activeAppointment.procedureDescription }}</div>
              </div>
            </td>
            <td>
              <div>
                <div data-cy="patient-portal-home-appointment-location-label"><i class="tiny-icon material-symbols-outlined">map</i> {{ activeAppointment.locationAddress }}
              </div>
              <div data-cy="patient-portal-home-appointment-phone-label"><i class="tiny-icon material-symbols-outlined">call</i> {{ activeAppointment.locationPhone }}
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <div class="horizontal-separator"></div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div>
            <div data-cy="patient-portal-home-check-in-label">For Check-in</div>
            <div style="display: flex;">
              <div class="button" data-cy="patient-portal-home-send-to-mobile-button" style="width: 160px;margin-top: 5px;" color="primary"
                [class.disabled-content]="activeAppointment.isOld || activeAppointment.smsSent || isSendingSMS"
                (click)="sendToMobile()" (onKeyPress)="SendToMobileKey($event)">
                @if (!isSendingSMS) {
                  <span>Send to my Mobile</span>
                }
                @if (isSendingSMS) {
                  <mat-spinner class="mini-spinner" [diameter]="20"></mat-spinner>
                }
              </div>
              <div class="button" data-cy="patient-portal-home-print-appointment-button" style="width: 100px;margin-top: 5px; margin-left: 15px;" color="primary"
                [class.disabled-content]="activeAppointment.isOld" (click)="printAppointment(activeAppointment)">
              Print</div>
              <div>
                <img alt="Open Map" data-cy="patient-portal-home-open-map-button"
                  style="height: 35px; cursor: pointer;float: right;margin-top: 5px; margin-left: 15px;"
                  (click)="openMap()" src="assets/Images/map-icon.png">
                </div>
              </div>
            </div>
          </td>
          <td>
            <div>
              <div data-cy="patient-portal-home-complete-forms-label">Complete Your Forms</div>
              @if (!formsLoading) {
                <div class="general-content-container">
                  @if (!formsPending?.length) {
                    <div class="no-task-message" data-cy="patient-portal-home-no-tasks-message">
                      You have no tasks due at this time.
                    </div>
                  }
                  @if (formsPending?.length>0) {
                    <div class="task-name" data-cy="patient-portal-home-pending-forms-count">
                      You have {{ formsPending.length }} pending forms.
                    </div>
                  }
                </div>
              }
            </div>
            @if (activeAppointment.correspondence.length>0) {
              <div class="button" data-cy="patient-portal-home-correspondence-button"
                style="width: 120px;margin-top: 5px; margin-left: 15px;" color="primary"
              (click)="openCorrespondence(activeAppointment.AppointmentId)">Correspondence</div>
            }
          </td>
          <td>
          </td>
        </tr>
      </table>
    </div>
  }
</mat-expansion-panel>
<mat-expansion-panel>
  <mat-expansion-panel-header class="panel-style" data-cy="patient-portal-home-upcoming-appointments-panel-header">
    <mat-panel-title data-cy="patient-portal-home-upcoming-appointments-panel-title"> Upcoming appointments </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="content-container">
    <div class="general-container">
      <div class="general-content-container">
        @if (appointments?.length===0) {
          <div class="general-content-container pre-appointment-container">
            <span class="container-title" data-cy="patient-portal-home-no-upcoming-appointments-text">No Pending Appointments</span>
          </div>
        }
        @for (appointment of appointments; track appointment) {
          <div class="appointment" data-cy="patient-portal-home-upcoming-appointment-item" (click)="selectAppointment(appointment)">
            <div class="appointment-content"
              [class.appointment-active]="activeAppointmentId === appointment.AppointmentId">
              <div class="appointment-upcoming-data">
                <div class="appointment-title" data-cy="patient-portal-home-upcoming-appointment-title-label">{{ appointment.displayTitle }} </div>
                <br><span data-cy="patient-portal-home-upcoming-appointment-procedure-label">{{ appointment.procedureDescription }}</span>
                  <br><span data-cy="patient-portal-home-upcoming-appointment-doctor-label">{{ appointment.doctor }}</span>
                    <br><span data-cy="patient-portal-home-upcoming-appointment-location-label">{{ appointment.locationAddress }}</span>
                    </div>
                    <div class="appointment-actions" [class.disabled-content]="appointment.isOld" style="float:right">
                      <div class="button" data-cy="patient-portal-home-confirm-appointment-button" style="width: 160px;margin-top: 5px;" color="primary"
                        [class.disabled-content]="appointment.enumApptStatusId === enumConfirmedStatus || appointment.isOld"
                        (click)="confirmAppointment(appointment)">{{ appointment.enumApptStatusId ===
                        enumConfirmedStatus ?
                      'Confirmed' : 'Confirm Appointment' }}</div>
                      <div class="button" data-cy="patient-portal-home-reschedule-button" style="width: 160px;margin-top: 5px;" color="primary"
                        [class.disabled-content]="appointment.isOld" (click)="rescheduleAppointment(appointment)">Request
                      Reschedule</div>
                    </div>
                  </div>
                  <div class="vertical-separator"></div>
                </div>
              }
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel #panel>
        <mat-expansion-panel-header class="panel-style" data-cy="patient-portal-home-forms-panel-header">
          <mat-panel-title style="display: flex; align-items: center;">
            <span data-cy="patient-portal-home-forms-title">Forms</span>
            @if (!isLoading && panel.expanded) {
              <div style="padding-left: 40px;">
                @if (isformViewMinimized) {
                  <div matTooltip="Expand Form List" data-cy="patient-portal-home-expand-form-list-button"
                    (click)="toggleFormView($event)"
                    class="form-view-collapsed">
                    <lucide-icon name="chevron-right" [size]="20" style="transform: scale(1.76, 1.7); cursor: pointer;"></lucide-icon>
                  </div>
                }
                <!-- <div *ngIf="!isformViewMinimized" matTooltip="Collapse Form List"
                (click)="toggleFormView($event)"
                class="form-view-collapsed"
                style="cursor: pointer;">
                <lucide-icon name="chevron-left" [size]="20" style="transform: scale(1.76, 1.7);"></lucide-icon>
              </div> -->
            </div>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="content-container forms-container">
        <div class="general-container"
          style="min-height: calc(100% - 50px);max-height: calc(100% - 50px);overflow: auto;">
          <div class="general-content-container" style="width: 100%">
            @if (!isformViewMinimized) {
              <div class="form-listTablet">
                @for (treatment of patientTreatments; track treatment) {
                  <div class="form-tile" [class.active-form]="selectedTreatmentPlanningID === treatment.TreatmentPlanningID"
                    data-cy="patient-portal-treatment"
                    [class.form-completed]="['Accepted', 'Rejected'].includes(treatment.Status)"
                    (click)="loadTreatmentToContainer(treatment)">
                    <span data-cy="patient-portal-form-description"
                      style="color: var(--accented-text-color);font-size: small; font-weight: 600;">{{treatment.ParentDescription}}
                    - {{treatment.Description}}</span><br />
                    Status: <span style="font-size: smaller;" data-cy="patient-portal-status"
                  [class.status-completed]="'Accepted' === treatment.Status">{{treatment.Status}}</span>
                </div>
              }
              @for (patientForm of patientForms; track patientForm) {
                <div class="form-tile"
                  [class.active-form]="selectedCaseWorkItemFormsID === patientForm.CaseWorkItemFormsId"
                  data-cy="patient-portal-form"
                  [class.form-completed]="['Completed/Signed', 'Completed'].includes(patientForm.Status)"
                  (click)="loadFormToContainer(patientForm)">
                  <span data-cy="patient-portal-form-description"
                  style="color: var(--accented-text-color);font-size: small; font-weight: 600;">{{patientForm.Description}}</span><br />
                  Status: <span style="font-size: smaller;" data-cy="patient-portal-status"
                [class.status-completed]="['Completed/Signed', 'Completed'].includes(patientForm.Status)">{{patientForm.Status}}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</mat-expansion-panel>
<mat-expansion-panel>
  <mat-expansion-panel-header class="panel-style" data-cy="patient-portal-home-recent-appointments-panel-header">
    <mat-panel-title data-cy="patient-portal-home-recent-appointments-panel-title"> Recent appointments </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="content-container">
    <div class="general-content-container calendar-container">
      <app-tdo-mini-calendar #calendar [isGetAppointmentDays]="false" [daysToHighlight]="daysToHighlight"
      style="width: 350px;" (selectedDateChange)="calendarUpdate($event)"></app-tdo-mini-calendar>
      <div class="button" data-cy="patient-portal-home-request-appointment-button" style="width: 160px;margin-top: 5px;" color="primary"
      (click)="requestAppointment(appointment)">Request Appointment</div>
    </div>
  </div>
  <div class="content-container">
    <div class="container-title" data-cy="patient-portal-home-recent-appointments-title">Recent Appointments</div>
    <div class="recent-appointments-container">
      @if (oldAppointments?.length===0) {
        <div class="general-content-container recent-appointment-container">
          <span class="container-title" data-cy="patient-portal-home-no-previous-appointments-text">No Previous Appointments</span>
        </div>
      }
      @for (appt of oldAppointments; track appt) {
        <div class="appointment-data recent-entity" data-cy="patient-portal-home-recent-appointment-item">
          <div style="display: flex;">
            <div style="display: flex;">
              <div style="font-size: xx-large;width: 40px; font-weight: 700;" data-cy="patient-portal-home-recent-appointment-day-label">{{ appt.appointmentDate.format('D') }}
              </div>
              <div style="width: 100px;" data-cy="patient-portal-home-recent-appointment-date-label">{{ appt.appointmentDate.format('MMM, YYYY')}}<br />{{
                appt.appointmentDate.format('H:mm A')}}
              </div>
            </div>
            <div style="font-size: small; width: 200px;">
              <div data-cy="patient-portal-home-recent-appointment-doctor-label"><i class="tiny-icon material-symbols-outlined">stethoscope</i> {{ appt.doctor }}</div>
              <div data-cy="patient-portal-home-recent-appointment-procedure-label"><i class="tiny-icon material-symbols-outlined">dentistry</i> {{ appt.procedureDescription }}</div>
            </div>
            <div style="font-size: small; width: 200px;">
              <div data-cy="patient-portal-home-recent-appointment-location-label"><i class="tiny-icon material-symbols-outlined">map</i> {{ appt.locationAddress }}</div>
              <div data-cy="patient-portal-home-recent-appointment-phone-label"><i class="tiny-icon material-symbols-outlined">call</i> {{ appt.locationPhone }}</div>
            </div>
          </div>
          @if (appt.correspondence.length>0) {
            <div style="text-align: center;" data-cy="patient-portal-home-recent-correspondence-button"
              (click)="openCorrespondence(appt.AppointmentId)">
              <div class="correspondence-label">Correspondence</div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</mat-expansion-panel>
<mat-expansion-panel>
  <mat-expansion-panel-header class="panel-style" data-cy="patient-portal-home-pending-payments-panel-header">
    <mat-panel-title data-cy="patient-portal-home-pending-payments-panel-title"> Pending Payments</mat-panel-title>
  </mat-expansion-panel-header>
  <div class="content-container">
    <div class="recent-invoices-container">
      @if (patientTransactions?.length===0) {
        <div class="general-content-container recent-appointment-container">
          <span class="container-title" data-cy="patient-portal-home-no-pending-transactions-text">No Pending Transactions</span>
        </div>
      }
      @for (transaction of patientTransactions; track transaction) {
        <div class="transaction-data-container recent-entity" data-cy="patient-portal-home-transaction-item"
          >
          <div class="transaction-data">
            <div style="flex-direction: row; display: flex;">
              <div style="font-size: xx-large;width: 40px; font-weight: 700;" data-cy="patient-portal-home-transaction-day-label">{{
              transaction.ItemDate.format('D') }}</div>
              <div style="width: 100px;" data-cy="patient-portal-home-transaction-date-label">{{ transaction.ItemDate.format('MMM, YYYY')}}<br />{{
                transaction.ItemDate.format('H:mm A')}}
              </div>
            </div>
            <div style="font-size: small; width: 200px;">
              @if (transaction.DoctorName) {
                <div data-cy="patient-portal-home-transaction-doctor-label"><i class="tiny-icon material-symbols-outlined">stethoscope</i> {{ transaction.DoctorName }}</div>
              }
            <div data-cy="patient-portal-home-transaction-location-label"><i class="tiny-icon material-symbols-outlined">map</i> {{ transaction.LocationName }}</div>
          </div>
          <div>
            <div data-cy="patient-portal-home-transaction-amount-label">Total: {{ transaction.Amount | currency }}</div>
          </div>
        </div>
        <div style="text-align: center;">
          <div class="payment-pending" data-cy="patient-portal-home-transaction-payment-due-label">Your payment of {{transaction.AmountDuePatient | currency}} is due</div>
        </div>
      </div>
    }
    @if (patientTransactions?.length>0) {
      <div
        class="button"
        data-cy="pay-now-btn"
        style="width: 120px; margin: 10px auto; cursor: pointer;"
        color="primary"
        [class.disabled-content]="isRefreshingTransactions"
        (click)="openPayNowDialog()">
        @if (!isRefreshingTransactions) {
          <span>Pay Now</span>
        }
        @if (isRefreshingTransactions) {
          <mat-spinner class="mini-spinner" [diameter]="20"></mat-spinner>
        }
      </div>
    }
  </div>
</div>
</mat-expansion-panel>
</mat-accordion>
</div>
}
@if (isLoading) {
  <div class="spinner-container" data-cy="patient-portal-home-loading-spinner">
    <mat-spinner data-cy="patient-portal-home-spinner"></mat-spinner>
  </div>
}